webpackJsonp([272],{

/***/ 2510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {
      table: [{
        key: 'id',
        label: 'banner管理ID',
        value: ''
      }, {
        key: 'app_types',
        label: '上架APP',
        value: ''
      }, {
        key: 'name',
        label: 'banner管理名称',
        value: ''
      }, {
        key: 'created_at',
        text: '添加日期'
      }, {
        key: 'updated_at',
        text: '更新日期'
      }]
    };
  },

  computed: Vuex.mapState({
    appTypeList: function appTypeList(state) {
      return state.order && state.order.options && state.order.options.app_type_list || [];
    }
  }),
  created: function created() {
    this.id = this.$route.params.id;
    this.id > 0 && this.setDetailData(this.id);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    setDetailData: function setDetailData(id) {
      var _this = this;

      request.page('getAppBannerDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this.table.forEach(function (obj) {
          if (obj.key === 'app_types') {
            obj.value = _this.formatAppTypes(data.app_types);
            return;
          }
          if (data[obj.key]) {
            obj.value = data[obj.key];
          }
        });
      });
    },
    formatAppTypes: function formatAppTypes(raw) {
      if (raw === undefined || raw === null || raw === '') {
        return '-';
      }
      var labelMap = {};
      this.appTypeList.forEach(function (item) {
        labelMap[Number(item.value)] = item.label;
      });
      return String(raw).split(',').map(function (s) {
        return Number(String(s).trim());
      }).filter(function (v) {
        return labelMap[v];
      }).map(function (v) {
        return labelMap[v];
      }).join('、') || '-';
    }
  })
});

/***/ }),

/***/ 3147:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3148);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6235cb06", content, true, {});

/***/ }),

/***/ 3148:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AppBannerDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3149:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3150);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("beabddc4", content, true, {});

/***/ }),

/***/ 3150:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AppBannerDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3151:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3152);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("d8560460", content, true, {});

/***/ }),

/***/ 3152:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AppBannerDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/app-banner/table"}},[_vm._v("banner列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-table',{staticClass:"margin b15",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","show-header":false}},[_c('el-table-column',{attrs:{"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.value))])]}}])})],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/app-banner/table"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBannerDetail_vue__ = __webpack_require__(2510);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fdf4968_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBannerDetail_vue__ = __webpack_require__(3153);
function injectStyle (ssrContext) {
  __webpack_require__(3147)
  __webpack_require__(3149)
  this["$style"] = __webpack_require__(3151)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fdf4968"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBannerDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fdf4968_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBannerDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/app-banner-detail.d5f1e7a6a83afaa1ae74.js